import api from '../../../../api/client';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ListGroup, Dropdown, Media, Badge } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import PerfectScrollbar from 'react-perfect-scrollbar';
import axios from 'axios';
import ChatList from './ChatList';
import { API_SERVER } from '../../../../config/constant';
import { LOGOUT } from './../../../../store/actions';
import avatar1 from '../../../../assets/images/user/avatar-1.jpg';
import avatar2 from '../../../../assets/images/user/avatar-2.jpg';
import avatar3 from '../../../../assets/images/user/avatar-3.jpg';
import avatar4 from '../../../../assets/images/user/avatar-4.jpg';
import config from '../../../../config';
import socketIOClient from 'socket.io-client';
import RoleImpersonator from '../../../../views/dashboard/DashDefault/RoleImpasonator';

const NavRight = () => {
    const account = useSelector((state) => state.account);
    const dispatcher = useDispatch();
    const [listOpen, setListOpen] = useState(false);
    const history = useHistory();
    const [notifications, setNotifications] = useState([]); // State to store notifications
    const [unreadCount, setUnreadCount] = useState(0);
    const environment = window.location.hostname === 'localhost' ? 'development' : 'production';
    const apiUrl = config[environment].apiUrl;
    const [userRoles, setUserRoles] = useState([]);
    const [loading, setLoading] = useState(true);
    const user = account.user;

    const handleLogout = async () => {
        try {
            // socket.emit('logout', userId);
            await dispatcher({ type: 'LOGOUT' });
            history.push('/auth/signin');
        } catch (error) {
}
    };

    useEffect(() => {
        const fetchUserRoles = async () => {
            try {
                const response = await api.get(`/roles`);
                const rolesData = response.data;
                const options = rolesData.map((role) => ({
                    value: role.id,
                    label: role.name
                }));
                setUserRoles(options);
            } catch (error) {
} finally {
                setLoading(false); // ✅ Done loading whether success or error
            }
        };

        fetchUserRoles();
    }, [account, apiUrl]);

    const handlePass = async () => {
        history.push('/auth/password-change');
    };

    const handleSettingsPage = async () => {
        history.push('/settings');
    };

    const handleProfilePage = async () => {
        history.push('/profile');
    };

    const [impersonationToken, setImpersonationToken] = useState(localStorage.getItem('impersonationToken') || null);

    // Attach impersonation token to axios requests
    axios.interceptors.request.use((config) => {
        const impToken = localStorage.getItem('impersonationToken');
        if (impToken) {
            config.headers['x-impersonation-token'] = impToken;
        }
        return config;
    });

    const EMPLOYEE_ROLE_ID = user.is_admin;
    const logedRole = userRoles.find((o) => o.value === EMPLOYEE_ROLE_ID)?.label;
    const isAdmin = logedRole && logedRole.toLowerCase().includes('admin');

    if (loading) {
        return <div>Loading...</div>; // or a spinner
    }

    return (
        <React.Fragment>
            <ListGroup as="ul" bsPrefix=" " className="navbar-nav ml-auto" id="navbar-right">
                <ListGroup.Item as="li" bsPrefix=" ">
                    {/* <span>
                  Hi,  {account.user.firstname} {account.user.lastname}
                </span> */}
                    {/* <Dropdown>
                        <Dropdown.Toggle as={Link} variant="link" to="#" id="dropdown-basic">
                        <i className="feather icon-bell icon" />
                        {unreadCount > 0 && (
                            <Badge variant="danger">{unreadCount}</Badge> // Display a badge with unread count
                        )}
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight className="notification notification-scroll">
                        <div className="noti-head">
                            <h6 className="d-inline-block m-b-0">Notifications</h6>
                            <div className="float-right">
                            <Link to="#" className="m-r-10">
                                Mark as read
                            </Link>
                            <Link to="#">Clear all</Link>
                            </div>
                        </div>
                        <PerfectScrollbar>
                            <ListGroup as="ul" bsPrefix=" " variant="flush" className="noti-body">
                            {notifications.map((notification, index) => (
                                <ListGroup.Item
                                as="li"
                                bsPrefix=" "
                                className={`notification ${notification.read ? 'read' : 'unread'}`}
                                key={index}
                                >
                                <Media>
                                    <img className="img-radius" src={notification.avatar} alt="Generic placeholder" />
                                    <Media.Body>
                                    <p>
                                        <strong>{notification.sender}</strong>
                                        <span className="n-time text-muted">
                                        <i className="icon feather icon-clock m-r-10" />
                                        {notification.timestamp}
                                        </span>
                                    </p>
                                    <p>{notification.message}</p>
                                    </Media.Body>
                                </Media>
                                </ListGroup.Item>
                            ))}
                            </ListGroup>
                        </PerfectScrollbar>
                        <div className="noti-footer">
                            <Link to="#">Show all</Link>
                        </div>
                        </Dropdown.Menu>
                    </Dropdown> */}
                </ListGroup.Item>
                {/* <ListGroup.Item as="li" bsPrefix=" ">
                    <Dropdown>{generateGreeting()}</Dropdown>
                </ListGroup.Item> */}
                <ListGroup.Item as="li" bsPrefix=" ">
                    <Dropdown>
                        <Dropdown.Toggle as={Link} variant="link" to="#" className="displayChatbox" onClick={() => setListOpen(true)}>
                            <i className="icon feather icon-mail" />
                        </Dropdown.Toggle>
                    </Dropdown>
                </ListGroup.Item>
                <ListGroup.Item as="li" bsPrefix=" ">
                    <Dropdown className="drp-user">
                        <Dropdown.Toggle as={Link} variant="link" to="#" id="dropdown-basic">
                            <i className="icon feather icon-settings" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu alignRight className="profile-notification">
                            <div className="pro-head">
                                {account.user.passport ? (
                                    <img
                                        src={`/uploads/${account.user.passport}` || avatar1}
                                        className="img-radius"
                                        alt="User Passport"
                                        style={{
                                            width: '40px', // Adjust the width as needed
                                            height: '40px',
                                            borderRadius: '50%',
                                            objectFit: 'cover'
                                        }}
                                    />
                                ) : (
                                    <img src={avatar1} className="img-radius" alt="User Profile" />
                                )}
                                <span>
                                    {account.user.firstname} {account.user.lastname}
                                </span>

                                <Link to="#" className="dud-logout" onClick={handleLogout} title="Logout">
                                    <i className="feather icon-log-out" />
                                </Link>
                            </div>
                            <ListGroup as="ul" bsPrefix=" " variant="flush" className="pro-body">
                                {/* <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="#" className="dropdown-item">
                                        <i className="feather icon-settings" /> Settings
                                    </Link>
                                </ListGroup.Item> */}
                                <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="#" className="dropdown-item text-bg-dark text-capitalize">
                                        <i className="feather icon-activity" />{' '}
                                        {userRoles.find((o) => o.value === account?.user?.is_admin)?.label} Role
                                    </Link>
                                </ListGroup.Item>
                                <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="#" className="dropdown-item" onClick={handleProfilePage}>
                                        <i className="feather icon-user" /> Profile
                                    </Link>
                                </ListGroup.Item>
                                {/* <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="#" className="dropdown-item">
                                        <i className="feather icon-mail" /> My Messages
                                    </Link>
                                </ListGroup.Item> */}

                                <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="#" className="dropdown-item" onClick={handlePass}>
                                        <i className="feather icon-unlock" /> Change Password
                                    </Link>
                                </ListGroup.Item>
                                {/* {isAdmin && (
                                    <ListGroup.Item as="li" bsPrefix=" ">
                                        <Link to="#" className="dropdown-item" onClick={handleSettingsPage}>
                                            <i className="feather icon-settings" /> Settings
                                        </Link>
                                    </ListGroup.Item>
                                )} */}

                                <ListGroup.Item as="li" bsPrefix=" ">
                                    <Link to="#" className="dropdown-item" onClick={handleLogout}>
                                        <i className="feather icon-log-out" /> Logout
                                    </Link>
                                </ListGroup.Item>
                                {/* {isAdmin && (
                                    <ListGroup.Item as="li" bsPrefix=" ">
                                        <Link to="#" className="dropdown-item">
                                            <RoleImpersonator user={user} setImpersonationToken={setImpersonationToken} />
                                        </Link>
                                    </ListGroup.Item>
                                )} */}
                            </ListGroup>
                        </Dropdown.Menu>
                    </Dropdown>
                </ListGroup.Item>
            </ListGroup>
            <ChatList listOpen={listOpen} closed={() => setListOpen(false)} />
        </React.Fragment>
    );
};

export default NavRight;
